import coreStore from "./core-store";
import Axios from 'axios'

const storeFactory = () => {
    const remoteResource = 'resource/api/v1/files';

    const store = coreStore.queryStore(coreStore.createCoreStore('importFile', remoteResource));

    store.actions.deleteImportFile = ({commit}, {id}) => {

        return Axios.delete(`${remoteResource}/${id}`).then(() => {
            commit("removeImportFiles", (file) => file.id === id)
        })
    }
    return store;
}

export default storeFactory;